import { useEffect } from 'react';

const STORED_BUILD_TIME_KEY = 'app_build_time';

export function useAutoReload() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') return;

    const checkOnce = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        const latest = data.buildTime;
        if (!latest) return;

        const stored = localStorage.getItem(STORED_BUILD_TIME_KEY);

        if (stored && stored !== String(latest)) {
          console.log("🔄 [AutoReload] New build detected, reloading page");
          localStorage.setItem(STORED_BUILD_TIME_KEY, String(latest));
          window.location.reload();
        } else {
          localStorage.setItem(STORED_BUILD_TIME_KEY, String(latest));
        }
      } catch {
        // version.json недоступен — ничего не делаем
      }
    };

    checkOnce();
  }, []);
}
